import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Small inline error used next to the control whose action failed —
 * save buttons, submit buttons, mutation triggers. Keeps the user's
 * context intact (their typed data stays visible) and offers an
 * in-place retry, which a toast can't.
 *
 * Use this instead of an error toast for anything the user can retry.
 * Toasts remain appropriate for success confirmations only.
 */
@Component({
  selector: 'lib-inline-error',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './inline-error.html',
  styleUrls: ['./inline-error.scss'],
})
export class InlineErrorComponent {
  readonly message = input.required<string>();
  readonly detail = input<string | null>(null);
  /** When provided, a Retry button is rendered that emits (retry). */
  readonly retryable = input<boolean>(false);

  @Output() readonly retry = new EventEmitter<void>();
}
